module.exports = __webpack_public_path__ + "static/home-depot-59015f28af3d9f8f63c18b47756eaffe.png";